import { UIKitIcon } from '../icon';

export const phoneIcon: UIKitIcon = {
  name: 'phone',
  // eslint-disable-next-line max-len
  data: '<svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m11.691 7.151-2.803-.17a.569.569 0 0 0-.326.11.615.615 0 0 0-.212.284c-2.315 8.788 6.632 19.129 15.141 17.418a.601.601 0 0 0 .301-.218.651.651 0 0 0 .125-.36l.063-2.948c0-.394-.113-.447-.376-.565l-4.054-1.474a.714.714 0 0 0-.588.171l-1.402 1.08c-2.503-.343-5.556-3.855-5.668-6.579l1.138-1.315a.769.769 0 0 0 .173-.284.8.8 0 0 0 .04-.335l-1.014-4.354c0-.237-.162-.395-.538-.46Z" stroke="#fff" stroke-linejoin="round"/></svg>',
};
